import _get from 'lodash/get';
import { FEE_TYPE } from './stubs';

/** @returns {import("zod").z.infer<typeof import("./stubs").FORM_SCHEMA>} */
export const createFormData = data => {
  const feesEnabled = _get(data, 'fees.enabled', false);
  const amount = _get(data, 'fees.amount', '');
  const ceilingAmount = _get(data, 'fees.ceiling_amount', '');
  const feeType = _get(data, 'fees.fee_type', FEE_TYPE.fixed);

  return {
    fees_enabled: feesEnabled,
    fee_type: feeType,
    amount: `${amount}`,
    ceiling_amount:
      ceilingAmount === null || ceilingAmount === 'null'
        ? ''
        : `${ceilingAmount}`
  };
};

/**
 * @param {import("zod").z.infer<typeof import("./stubs").FORM_SCHEMA>} formData
 * @param {Object} opmData - Full OPM payment method data from API
 */
export const createPayload = (formData, opmData) => {
  return {
    ...opmData,
    fees: {
      allow: true,
      enabled: formData.fees_enabled,
      fee_type: formData.fee_type,
      amount: +formData.amount,
      ceiling_amount:
        formData.ceiling_amount && formData.ceiling_amount !== ''
          ? +formData.ceiling_amount
          : 0
    }
  };
};
